<div class="container text-center py-5" data-cy="server-down">
  <div class="row justify-content-center">
    <button
      class="btn btn-primary"
      cue-button
      size="small"
      data-cy="server-down-refresh"
      (click)="forceManualTrigger()"
    >
      <cue-icon [icon]="ICONS.cueRefresh"></cue-icon>
      {{ translation.common.refresh | transloco }}
    </button>
    {{ translation.common.reloadIn | transloco }}: {{ countDown() }}s

    <div class="col-md-6">
      <img src="assets/images/navigation/background.png" alt="Navigation is not enabled" class="img-fluid mb-4" />

      <h2 class="mb-3">{{ 'navigation.serverDown' | transloco }}</h2>
      ({{ translation.common.serverDownTimer | transloco }}:
      {{ (checkServerOnlineSignal() * refreshIntervalInSec) / 60 }} min.)
    </div>
  </div>
</div>
